import { action } from 'typesafe-actions';
import { AgencyActionTypes } from './types';
import { IAgent } from '../../types';

export const getAgencies = () => action(AgencyActionTypes.GET_AGENCIES);
export const getAgenciesSuccess = (agencies: Array<IAgent>) => action(AgencyActionTypes.GET_AGENCIES_SUCCESS, agencies);
export const getAgenciesFailure = (error: string) => action(AgencyActionTypes.GET_AGENCIES_FAILURE, error);

export const getAgentAliases = () => action(AgencyActionTypes.GET_AGENT_ALIASES);
export const getAgentAliasesSuccess = (aliases: Array<IAgent>) =>
  action(AgencyActionTypes.GET_AGENT_ALIASES_SUCCESS, aliases);
export const getAgentAliasesFailure = (error: string) => action(AgencyActionTypes.GET_AGENT_ALIASES_FAILURE, error);

export const getAgencyById = (agencyId: string, checkApplyAccess?: boolean) =>
  action(AgencyActionTypes.GET_AGENCY_BY_ID, { agencyId, checkApplyAccess });
export const getAgencyByIdSuccess = (agencies: Array<IAgent>) =>
  action(AgencyActionTypes.GET_AGENCY_BY_ID_SUCCESS, agencies);
export const getAgencyByIdFailure = (error: string) => action(AgencyActionTypes.GET_AGENCY_BY_ID_FAILURE, error);

export const saveAgencyRecord = (agency: any) => {
  return action(AgencyActionTypes.SAVE_AGENCY, agency);
};
export const saveAgencyRecordSuccess = (agency: any) => action(AgencyActionTypes.SAVE_AGENCY_SUCCESS, agency);
export const saveAgencyRecordFailure = (error: string) => action(AgencyActionTypes.SAVE_AGENCY_FAILURE, error);

export const deleteAgency = (username: string) => action(AgencyActionTypes.DELETE_AGENCY, username);
export const deleteAgencySuccess = (username: string) => action(AgencyActionTypes.DELETE_AGENCY_SUCCESS, username);
export const deleteAgencyFailure = (error: string) => action(AgencyActionTypes.DELETE_AGENCY_FAILURE, error);
